const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[{}|:;"'<>,.?/~])[A-Za-z\d!@#$%^&*()_+\-=[{}|:;"'<>,.?/~]{8,}$/;
// const emailRegex = /\S+@\S+\.\S+/;
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z]+\.[a-zA-Z]{2,}$/;
const websiteRegex = /^(https?:\/\/)?([\w-]+\.)+(com|in|org|net|co\.in|io)(\/[\w-]*)*\/?$/;
// const urlRegex = /^https?:\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=]*)?$/;
// const urlRegex = /^(https?:\/\/)?([\w-]+\.)+(com|in|org|net|co\.in|io)(\/[\w-]*)*\/?$/;
const urlRegex = /^(https?:\/\/)?(www\.)?([\w-]+\.)+[a-zA-Z]{2,}(\/[\w-]*)*\/?$/
const phoneNumberRegex = /^\d{10}$/;
const phoneNumberRangeRegex = /^\d*$/;

export {
  passwordRegex,
  emailRegex,
  urlRegex,
  websiteRegex,
  phoneNumberRegex,
  phoneNumberRangeRegex
};
